import { observer } from "mobx-react";
import React from "react";
import { useParams } from "react-router";
import { useQuery } from "@tanstack/react-query";
import apiAgent from "../../app/api/apiAgent";
import { ContactModel } from "../../app/models/ContactModel";
import { useStore } from "../../app/stores/store";
import Header from "../header/Header";
import HeaderWrapper from "../header/HeaderWrapper";

//import "../../assets/styles/components/_saveContact.scss";
import ContactBox from "./ContactBox";
import AjaxLoader from "../../app/common/common-components/AjaxLoader";
import Breadcrumb from "../../app/common/common-components/Breadcrumb";

// Custom hook for fetching contact data
const useContact = (contactId: string) => {
  return useQuery({
    queryKey: ["contact", contactId],
    queryFn: async () => {
      const response = await apiAgent.Contact.saveContact(
        contactId,
        "",
        "",
        ""
      );
      // The API returns a JSON string that needs to be parsed
      return typeof response === "string"
        ? (JSON.parse(response) as ContactModel)
        : (response as ContactModel);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });
};

export default observer(function SaveContactPage() {
  const {
    userStore: { userSession, logout, isLoggedIn },
  } = useStore();

  // Get contact ID from URL parameters
  const params = new URLSearchParams(window.location.search);
  const contactId = params.get("ID") || "";

  // Use React Query to fetch contact data
  const { data: contact, isLoading, error } = useContact(contactId);

  document.title = "Base - Save Contact";

  if (isLoading) {
    return <AjaxLoader />;
  }

  if (error) {
    return (
      <div className="tw-container tw-mx-auto tw-px-4 tw-py-8">
        <div className="tw-text-center">
          <h2 className="tw-text-xl tw-font-semibold tw-text-red-600">
            Error loading contact
          </h2>
          <p className="tw-mt-2 tw-text-gray-600">Please try again later.</p>
        </div>
      </div>
    );
  }

  if (!contact) {
    return (
      <div className="tw-container tw-mx-auto tw-px-4 tw-py-8">
        <div className="tw-text-center">
          <h2 className="tw-text-xl tw-font-semibold tw-text-gray-600">
            Contact not found
          </h2>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* <Header /> */}

      <div className="save-contact container-fluid">
        <Breadcrumb
          breadcrumbs={[
            { text: "Home", path: "/" },
            { text: "Contacts", path: "/contacts" },
            { text: contact?.displayName },
          ]}
        />

        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-md-12 col-md-8">
            <ContactBox contact={contact} />
          </div>
        </div>
      </div>
    </>
  );
});
